import React, { useState, useEffect } from "react";
import "./css/Projects.css";
import { motion } from "framer-motion";
import axios from "axios";


export default function Projects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  
  useEffect(() => {
    const apiProjectUrl = process.env.REACT_APP_API_PROJECTS;
    axios.get(`${apiProjectUrl}`)
      .then((response) => {
        setProjects(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching projects:", error);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading projects...</div>;

  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      style={{ minHeight: "100vh" }}
      className="projects-bg"
    >
    <section >
      <h2 className="projects-title">My Work</h2>
      <div >
        {[...projects].reverse().map((proj, idx) => (
          <div className="project-card" key={idx}>
            <h3 className="project-card-title">{proj.title}</h3>
            <p className="project-card-desc">{proj.description}</p>
            <div className="project-tech">
              {proj.tech.split(',').map((t, i) => (
                <span key={i} className="project-tech-tag">{t.trim()}</span>
            ))}

            </div>
            <div className="project-links">
              {proj.live_url && (
                <a href={proj.live_url} target="_blank" rel="noopener noreferrer" className="project-link">
                  Live Demo
                </a>
              )}
              {proj.source_url && (
              <a href={proj.source_url} target="_blank" rel="noopener noreferrer" className="project-link">
                Source Code
              </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
    </motion.section>
  );
}
